<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="备注"
      width="800px"
      :innerHeight="300"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <!-- <el-form :model="form" size="small" label-width="50px" ref="ruleForm" :rules="rules">
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="6" show-word-limit maxlength="300"></el-input>
        </el-form-item>
      </el-form> -->
      <div style="text-align: right; margin-bottom: 10px;">
        <el-link type="primary" :underline="false" @click="addRemark">新增备注</el-link>
      </div>
      <el-table :data="tableData" border height="230px">
        <el-table-column label="操作人" prop="operator"></el-table-column>
        <el-table-column label="操作时间" prop="operationTime"></el-table-column>
        <el-table-column label="对应sku" prop="task">
          <template slot-scope="scope">
            <span v-if="scope.row.temp">
              <el-select v-model="scope.row.task" size="small">
                <el-option
                  :label="`${skuInfo.skuCode}-${skuInfo.taskName}`"
                  :value="skuInfo.skuCode"
                  v-for="skuInfo in finalSkuList" :key="skuInfo.code"></el-option>
              </el-select>
            </span>
            <span v-else>{{scope.row.task}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark">
          <template slot-scope="scope">
            <span v-if="scope.row.temp">
              <el-input v-model="scope.row.remark" type="textarea" :rows="2" size="small"></el-input>
            </span>
            <span v-else>{{scope.row.remark}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationOpt.pageNum"
          :page-sizes="paginationOpt.pageSizes"
          :page-size="paginationOpt.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paginationOpt.total">
        </el-pagination>
      </div>
    </q-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'spuId', 'skuList'],
  data() {
    return {
      dialogVisible: false,
      // 业务
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      global_userName: 'name',
    }),
    // 过滤掉处于完成上架节点的sku
    finalSkuList() {
      return this.skuList.filter(v=>{
        return v.taskId != 110
      })
    },
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
      this.$emit('close', null)
    },
    confirm() {
      this.submit();
    },
    // 业务
    init() {
      this.loading = true;
      let data = {
        filterData: {
          spuId: this.spuId
        },
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
      }
      this.$q.newProduct.queryProductRemark({data})
      .then(res=>{
        if(res.code == 200) {
          this.tableData = res.data.records;
          this.paginationOpt['total'] = res.data.total;
        }else{
          this.$message.error(res.message)
        }
      })
      .catch(err=>{
        this.$message.error(err.message)
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    submit() {
      let data = this.tableData.filter(v=>v.temp)[0];
      data['skuCode'] = data.task
      data['schedule'] = this.finalSkuList.find(v=>v.skuCode === data.skuCode).taskName;
      this.$q.newProduct.addProductRemark({data: {
        spuId: this.spuId,
        ...data
      }})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.message)
        }
      })
      .finally(_=>{
        this.updateVal();
      })
      .catch(err=>{
        this.$message.error(err.message)
      })
    },
    addRemark() {
      if(this.tableData.find(v=>v.temp)) {
        this.$message.error('请先保存上一条数据！')
        return;
      }
      this.tableData.unshift({
        temp: true,
        operator: this.global_userName,
        operationTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        task: '',
        remark: ''
      })
    },
    // 分页器 pagesize
      handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-table tr:last-child .cell{
    white-space: pre-line !important
  }
</style>